/**
 *
 * @type {string}
 */
export const BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://api.rushdelivery.app';
export const BASE_URL_WS = BASE_URL.replace('http', 'ws');
